import { render, staticRenderFns } from "./priceNoteUpdateDialog.vue?vue&type=template&id=21c80c10"
import script from "./priceNoteUpdateDialog.vue?vue&type=script&lang=js"
export * from "./priceNoteUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports